import axios from '../api/BaseURL'
import authHeader from './auth-header'

class connectionType {
  // connectionType type create
  createConnectionType(data) {
    return axios.post('/connection_type/add', data, { headers: authHeader() })
  }

  // list
  typeList() {
    return axios.get('/connection_type/list', { headers: authHeader() })
  }
  // list
  typeActiveList() {
    return axios.get('/connection_type/activeList', { headers: authHeader() })
  }

  // connectionType type update

  // connectionType type delete
  deleteConnectionType(id) {
    return axios.delete('/connection_type/delete', {
      headers: authHeader(),
      data: {
        id: id,
      },
    })
  }

  // change status
  changeStatus(id) {
    return axios.put(
      '/connection_type/changeConnectionTypeStatus',
      {
        id: id,
      },
      {
        headers: authHeader(),
      },
    )
  }

  // connectionType type update
  updateConnectionType(data) {
    return axios.put('/connection_type/update', data, {
      headers: authHeader(),
    })
  }
}
export default new connectionType()
